"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rufina": {
    "5cbf49ff": [{
      "hkey": "01e7f7f2",
      "slug": "rufina",
      "name": "Rufina",
      "primary": true,
      "skipSearch": false
    }],
    "agna": [{
      "hkey": "01e7f7f2",
      "slug": "rufina",
      "name": "Rufina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "11debd6e": [{
      "hkey": "01e7f7f2",
      "slug": "rufina",
      "name": "Rufina",
      "primary": true,
      "skipSearch": false
    }],
    "cigliano": [{
      "hkey": "01e7f7f2",
      "slug": "rufina",
      "name": "Rufina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c5cf4d7": [{
      "hkey": "01e7f7f2",
      "slug": "rufina",
      "name": "Rufina",
      "primary": true,
      "skipSearch": false
    }],
    "petrognano": [{
      "hkey": "01e7f7f2",
      "slug": "rufina",
      "name": "Rufina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d7897b3": [{
      "hkey": "bb1f6b70",
      "slug": "pomino",
      "name": "Pomino",
      "primary": true,
      "skipSearch": false
    }],
    "pomino-castelnuovo": [{
      "hkey": "bb1f6b70",
      "slug": "pomino",
      "name": "Pomino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "326ef0df": [{
      "hkey": "3f47aa87",
      "slug": "turicchi",
      "name": "Turicchi",
      "primary": true,
      "skipSearch": false
    }],
    "turicchi-pianettole": [{
      "hkey": "3f47aa87",
      "slug": "turicchi",
      "name": "Turicchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;